export default async function isAuth({ next, store, nextMiddleware }) {
  if (!store.getters.isAuthorised) {
    return next({
      name: 'Login',
    })
  }
  return nextMiddleware()
}
